import CreditCardIcon from '@/assets/icons/support_ticket/credit-card.svg?inline'
import FileTextIcon from '@/assets/icons/support_ticket/file-text.svg?inline'
import LayoutDashboardIcon from '@/assets/icons/support_ticket/layout-dashboard.svg?inline'
import CoinIcon from '@/assets/icons/support_ticket/coin.svg?inline'
import SchoolIcon from '@/assets/icons/support_ticket/school.svg?inline'

export const categoryIcons = {
  'ti-credit-card': CreditCardIcon,
  'ti-file-text': FileTextIcon,
  'ti-layout-dashboard': LayoutDashboardIcon,
  'ti-coin': CoinIcon,
  'ti-school': SchoolIcon,
}
